import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ['discount', 'discountVisibility', 'annualPrice', 'totalDueToday', 'planPackage', 'form']

  connect() {
    this.initializePlanPricing();
  }

  changePlan(event) {
    const planPackage = event.target.value;
    this.updatePlanEstimate(planPackage);
  }

  initializePlanPricing() {
    const form = this.formTarget;
    const radioInputs = $(form).find('input[type="radio"]');

    radioInputs.each((index, element) => {
      const planPackage = $(element).val();
      this.fetchPlanEstimate(planPackage, (data) => {
        this.updateLicenseCost(element, data);
      });
    });
  }

  updatePlanEstimate(planPackage) {
    this.fetchPlanEstimate(planPackage, (data) => {
      this.updatePlanDetails(planPackage, data);
    });
  }

  fetchPlanEstimate(planPackage, successCallback) {
    const params = this.buildEstimateParams(planPackage);
    const url = this.buildEstimateUrl(params);

    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: successCallback,
      error: this.handleAjaxError.bind(this)
    });
  }

  buildEstimateParams(planPackage) {
    return {
      subscription: {
        quantity: this.data.get('quantity'),
        unit: this.data.get('unit'),
        plan_package: planPackage,
        mode: this.data.get('mode')
      }
    };
  }

  buildEstimateUrl(params) {
    const companyId = this.data.get('company-id');
    const queryString = jQuery.param(params);
    return `${window.location.origin}/companies/${companyId}/subscriptions/estimate?${queryString}`;
  }

  updateLicenseCost(element, data) {
    const licenseCostSpan = $(element).closest('div').find('#licenseCost');
    if (licenseCostSpan.length && data.license_cost) {
      licenseCostSpan.text(data.license_cost);
    }
  }

  updatePlanDetails(planPackage, data) {
    this.planPackageTarget.value = planPackage;
    this.updateDiscountVisibility(data.discount);
    this.updatePriceFields(data);
  }

  updateDiscountVisibility(discount) {
    const hasDiscount = discount && discount !== '$0.00';

    if (hasDiscount) {
      this.discountVisibilityTarget.classList.remove('d-none');
      this.discountTarget.textContent = discount;
    } else {
      this.discountVisibilityTarget.classList.add('d-none');
    }
  }

  updatePriceFields(data) {
    if (data.annual_price) {
      this.annualPriceTarget.textContent = data.annual_price;
    }
    if (data.total_due_today) {
      this.totalDueTodayTarget.textContent = data.total_due_today;
    }
  }

  handleAjaxError(xhr, status, error) {
    console.error('LMS Upgrade Controller Error:', { xhr, status, error });
    const errorMessage = xhr.responseJSON?.message || 'An error occurred while updating plan information. Please try again.';

    alert(errorMessage);
  }
}
